var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallGuestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "guest-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 17.921,
    height: 17.921,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15255",
    "data-name": "Group 15255",
    transform: "translate(3.205 1.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15256",
    "data-name": "Group 15256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34086",
    "data-name": "Path 34086",
    d: "M265.294,464.289a4.51,4.51,0,0,0-4.507,4.512v1.289a.644.644,0,1,1-1.288,0V468.8a5.795,5.795,0,1,1,11.589,0v1.289a.644.644,0,1,1-1.288,0V468.8A4.51,4.51,0,0,0,265.294,464.289Z",
    transform: "translate(-259.5 -456.554)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34087",
    "data-name": "Path 34087",
    d: "M266.363,459.446a2.579,2.579,0,1,0-2.575-2.579A2.577,2.577,0,0,0,266.363,459.446Zm0,1.289a3.868,3.868,0,1,0-3.863-3.868A3.865,3.865,0,0,0,266.363,460.736Z",
    transform: "translate(-260.568 -453)",
    fill: "#6b6b95",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGuestIcon);
export default __webpack_public_path__ + "static/media/smallGuestIcon.51bf470aae251374ba70649a411f1f0c.svg";
export { ForwardRef as ReactComponent };